import { render, staticRenderFns } from "./Heroes.vue?vue&type=template&id=8e53cffe&scoped=true"
import script from "./Heroes.js?vue&type=script&lang=js&external"
export * from "./Heroes.js?vue&type=script&lang=js&external"
import style0 from "./Heroes.scss?vue&type=style&index=0&id=8e53cffe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e53cffe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
